export const COLOR_CONFIG = {
    black01: "#0B0B0C",
    black02: "#18181A",
    grey01: "#E2E2ED",
    grey02: "#B5B5C2",
    grey03: "#787885",
    grey04: "#515158",
    grey05: "#2D2D31",
    green01: "#00B272",
    orange01: "#FF4A00",
    orange02: "#FF6A2D",
    orange03: "#FFC2AA",
    white01: "#FFFFFF",
};

export const STYLES_CONFIG = {
    button: {
        backgroundColor: "transparent",
        border: "1px solid #ffffff",
        borderRadius: "8px",
        color: "#6c757d",
        active: {
            color: "#ffffff",
        },
    },
    toast: {
        color: "#ffffff",
        backgroundColor: "transparent",
        borderColor: "#ffffff",
    },
};

export const INSTRUMENTS_COLOR_MAP = {
    laser: "#EB2252",
    thunder: "#228BEB",
    lighter: "#FE6839",
};
